import { Caption } from 'blaze-ui/icons'
import { HoverActionOverlay, HoverActionOverlayProps } from 'components/HoverActionOverlay/HoverActionOverlay'
import { EditCaptionButton } from 'screens/Calendar/FullScreenPreview/EditPostMenu/EditCaptionButton'
import { ScheduledPostShow } from 'api/clients/ScheduledPostsClient'

export const EditCaptionOverlay = ({
  almanacFileKey,
  scheduledPost,
  ...props
}: Omit<HoverActionOverlayProps, 'onAction' | 'buttonLabel'> & {
  scheduledPost: ScheduledPostShow
  almanacFileKey: string
}) => {
  return (
    <HoverActionOverlay
      {...props}
      buttonLabel="Edit Caption"
      scrimOpacity={0}
      button={
        <EditCaptionButton
          scheduledPost={scheduledPost}
          almanacFileKey={almanacFileKey}
          variant="secondary"
          frontIcon={Caption}
          vertical={false}
          justifyContent="center"
          fullWidth={false}
          {...props.buttonProps}
        />
      }
    >
      {props.children}
    </HoverActionOverlay>
  )
}
